module.exports = __webpack_public_path__ + "static/media/card-ai-agent-br.666142fd.png";